import { render } from "./UserMessages.vue?vue&type=template&id=1eedd3d6&scoped=true"
import script from "./UserMessages.vue?vue&type=script&lang=ts"
export * from "./UserMessages.vue?vue&type=script&lang=ts"

import "./UserMessages.vue?vue&type=style&index=0&id=1eedd3d6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1eedd3d6"

export default script